'use strict';

var _regeneratorRuntime = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _defineProperty = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _asyncToGenerator = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _asyncIterator = require("/Users/filippo/Workspace/cloudest/clouest_client/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var uint8ArrayFromString = require('uint8arrays/from-string');

var uint8ArrayToString = require('uint8arrays/to-string');

var log = require('debug')('ipfs-http-client:pubsub:subscribe');

var SubscriptionTracker = require('./subscription-tracker');

var configure = require('../lib/configure');

var toUrlSearchParams = require('../lib/to-url-search-params');

module.exports = configure(function (api, options) {
  var subsTracker = SubscriptionTracker.singleton();
  return (
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(topic, handler) {
        var options,
            done,
            fail,
            result,
            ffWorkaround,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
                // eslint-disable-line require-await
                options.signal = subsTracker.subscribe(topic, handler, options.signal);
                result = new Promise(function (resolve, reject) {
                  done = resolve;
                  fail = reject;
                }); // In Firefox, the initial call to fetch does not resolve until some data
                // is received. If this doesn't happen within 1 second assume success

                ffWorkaround = setTimeout(function () {
                  return done();
                }, 1000); // Do this async to not block Firefox

                setTimeout(function () {
                  api.post('pubsub/sub', {
                    timeout: options.timeout,
                    signal: options.signal,
                    searchParams: toUrlSearchParams(_objectSpread({
                      arg: topic
                    }, options)),
                    headers: options.headers
                  }).catch(function (err) {
                    // Initial subscribe fail, ensure we clean up
                    subsTracker.unsubscribe(topic, handler);
                    fail(err);
                  }).then(function (response) {
                    clearTimeout(ffWorkaround);

                    if (!response) {
                      // if there was no response, the subscribe failed
                      return;
                    }

                    readMessages(response.ndjson(), {
                      onMessage: handler,
                      onEnd: function onEnd() {
                        return subsTracker.unsubscribe(topic, handler);
                      },
                      onError: options.onError
                    });
                    done();
                  });
                }, 0);
                return _context.abrupt("return", result);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
});

function readMessages(_x3, _x4) {
  return _readMessages.apply(this, arguments);
}

function _readMessages() {
  _readMessages = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee2(msgStream, _ref2) {
    var onMessage, onEnd, onError, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, msg;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            onMessage = _ref2.onMessage, onEnd = _ref2.onEnd, onError = _ref2.onError;
            onError = onError || log;
            _context2.prev = 2;
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _context2.prev = 5;
            _iterator = _asyncIterator(msgStream);

          case 7:
            _context2.next = 9;
            return _iterator.next();

          case 9:
            _step = _context2.sent;
            _iteratorNormalCompletion = _step.done;
            _context2.next = 13;
            return _step.value;

          case 13:
            _value = _context2.sent;

            if (_iteratorNormalCompletion) {
              _context2.next = 29;
              break;
            }

            msg = _value;
            _context2.prev = 16;

            if (msg.from) {
              _context2.next = 19;
              break;
            }

            return _context2.abrupt("continue", 26);

          case 19:
            onMessage({
              from: uint8ArrayToString(uint8ArrayFromString(msg.from, 'base64pad'), 'base58btc'),
              data: uint8ArrayFromString(msg.data, 'base64pad'),
              seqno: uint8ArrayFromString(msg.seqno, 'base64pad'),
              topicIDs: msg.topicIDs
            });
            _context2.next = 26;
            break;

          case 22:
            _context2.prev = 22;
            _context2.t0 = _context2["catch"](16);
            _context2.t0.message = "Failed to parse pubsub message: ".concat(_context2.t0.message);
            onError(_context2.t0, false, msg); // Not fatal

          case 26:
            _iteratorNormalCompletion = true;
            _context2.next = 7;
            break;

          case 29:
            _context2.next = 35;
            break;

          case 31:
            _context2.prev = 31;
            _context2.t1 = _context2["catch"](5);
            _didIteratorError = true;
            _iteratorError = _context2.t1;

          case 35:
            _context2.prev = 35;
            _context2.prev = 36;

            if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
              _context2.next = 40;
              break;
            }

            _context2.next = 40;
            return _iterator.return();

          case 40:
            _context2.prev = 40;

            if (!_didIteratorError) {
              _context2.next = 43;
              break;
            }

            throw _iteratorError;

          case 43:
            return _context2.finish(40);

          case 44:
            return _context2.finish(35);

          case 45:
            _context2.next = 50;
            break;

          case 47:
            _context2.prev = 47;
            _context2.t2 = _context2["catch"](2);

            // FIXME: In testing with Chrome, err.type is undefined (should not be!)
            // Temporarily use the name property instead.
            if (_context2.t2.type !== 'aborted' && _context2.t2.name !== 'AbortError') {
              onError(_context2.t2, true); // Fatal
            }

          case 50:
            _context2.prev = 50;
            onEnd();
            return _context2.finish(50);

          case 53:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 47, 50, 53], [5, 31, 35, 45], [16, 22], [36,, 40, 44]]);
  }));
  return _readMessages.apply(this, arguments);
}